import * as React from 'react';
import { styled, alpha } from '@mui/material/styles';
import Box from '@mui/material/Box';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Container from '@mui/material/Container';
import Divider from '@mui/material/Divider';
import MenuItem from '@mui/material/MenuItem';
import Drawer from '@mui/material/Drawer';
import MenuIcon from '@mui/icons-material/Menu';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import Sitemark from './SitemarkIcon';
import { Link as RSLink } from 'react-scroll';

const StyledToolbar = styled(Toolbar)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  flexShrink: 0,
  borderRadius: `calc(${theme.shape.borderRadius}px + 8px)`,
  backdropFilter: 'blur(24px)',
  border: '1px solid',
  borderColor: theme.palette.divider,
  backgroundColor: alpha(theme.palette.background.default, 0.4),
  boxShadow: theme.shadows[1],
  padding: '8px 12px',
}));

export default function AppAppBar() {
  const [open, setOpen] = React.useState(false);

  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen);
  };

  return (
    <AppBar
      position="fixed"
      sx={{ boxShadow: 0, bgcolor: 'transparent', backgroundImage: 'none', mt: 5 }}
    >
      <Container maxWidth="lg">
        <StyledToolbar variant="dense" disableGutters>
          <Box sx={{ flexGrow: 1, display: 'flex', alignItems: 'center', px: 0 }}>
            <Sitemark />
            <Box sx={{ display: { xs: 'none', md: 'flex' }, ml: 2 }}>
              <RSLink to="features" spy={true} smooth={true} offset={-70} duration={500}>
                <Button variant="text" color="info" size="small" >
                  Features
                </Button>
              </RSLink>
              <RSLink to="testimonials" spy={true} smooth={true} offset={-70} duration={500}>
                <Button variant="text" color="info" size="small">

                  Testimonials

                </Button>
              </RSLink>
              <RSLink to="highlights" spy={true} smooth={true} offset={-70} duration={500}>
                <Button variant="text" color="info" size="small">

                  Highlights

                </Button>
              </RSLink>
              <RSLink to="pricing" spy={true} smooth={true} offset={-70} duration={500}>
                <Button variant="text" color="info" size="small">

                  Pricing

                </Button>
              </RSLink>
              <RSLink to="faq" spy={true} smooth={true} offset={-70} duration={500}>
                <Button variant="text" color="info" size="small" sx={{ minWidth: 0 }}>

                  FAQ

                </Button>
              </RSLink>
              <RSLink to="contactus" spy={true} smooth={true} offset={-70} duration={500}>
                <Button variant="text" color="info" size="small" sx={{ minWidth: 0 }}>

                  Contact

                </Button>
              </RSLink>
            </Box>
          </Box>
          <Box
            sx={{
              display: { xs: 'none', md: 'flex' },
              gap: 1,
              alignItems: 'center',
            }}
          >
            <Button color="primary" variant="text" size="small" onClick={() => window.location.href = '/login'}>
              Sign in
            </Button>
            <Button color="primary" variant="contained" size="small" onClick={() => window.location.href = '/register'}>
              Sign up
            </Button>
          </Box>
          <Box sx={{ display: { sm: 'flex', md: 'none' } }}>
            <IconButton aria-label="Menu button" onClick={toggleDrawer(true)}>
              <MenuIcon />
            </IconButton>
            <Drawer anchor="top" open={open} onClose={toggleDrawer(false)}>
              <Box sx={{ p: 2, backgroundColor: 'background.default' }}>
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                  }}
                >
                  <IconButton onClick={toggleDrawer(false)}>
                    <CloseRoundedIcon />
                  </IconButton>
                </Box>
                <Divider sx={{ my: 3 }} />
                <RSLink to="features" spy={true} smooth={true} offset={-70} duration={500}>
                  <MenuItem>
                    Features
                  </MenuItem>
                </RSLink>
                <RSLink to="testimonials" spy={true} smooth={true} offset={-70} duration={500}>
                  <MenuItem>

                    Testimonials

                  </MenuItem>
                </RSLink>
                <RSLink to="highlights" spy={true} smooth={true} offset={-70} duration={500}>
                  <MenuItem>

                    Highlights

                  </MenuItem>
                </RSLink>
                <RSLink to="pricing" spy={true} smooth={true} offset={-70} duration={500}>
                  <MenuItem>

                    Pricing

                  </MenuItem>
                </RSLink>
                <RSLink to="faq" spy={true} smooth={true} offset={-70} duration={500}>
                  <MenuItem>

                    FAQ

                  </MenuItem>
                </RSLink>
                <RSLink to="contactus" spy={true} smooth={true} offset={-70} duration={500}>
                  <MenuItem>

                    Contact

                  </MenuItem>
                </RSLink>
                <MenuItem>
                  <Button color="primary" variant="outlined" fullWidth onClick={() => window.location.href = '/register'}>
                    Sign up
                  </Button>
                </MenuItem>
                <MenuItem>
                  <Button color="primary" variant="contained" fullWidth onClick={() => window.location.href = '/login'}>
                    Sign in
                  </Button>
                </MenuItem>
              </Box>
            </Drawer>
          </Box>
        </StyledToolbar>
      </Container>
    </AppBar>
  );
}
